import React, { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Avatar,
  Box,
  Button,
  Center,
  Text,
  VStack,
} from "@chakra-ui/react";
import TradingSpinner from "../TradingSpinner";

const ProfilePicDialog = ({
  isOpen,
  onClose,
  hasProfilePicture,
  profilePictureUrl,
  selectedFile,
  previewUrl,
  isLoading,
  onFileInputChange,
  onConfirm,
}) => {
  const cancelRef = useRef();
  const inputId = "profile-pic-upload";

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered={true}
      closeOnOverlayClick={true}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold" pb={1}>
            Change Profile Picture
          </AlertDialogHeader>
          <AlertDialogBody pt={1}>
            <Center>
              <Avatar
                className="avatar"
                src={hasProfilePicture ? profilePictureUrl : null}
                alt="Profile"
                size="xl"
              />
            </Center>
          </AlertDialogBody>
          <Center pt={3} pb={2}>
            <VStack spacing={3}>
              <input
                type="file"
                accept="image/*"
                hidden
                ref={cancelRef}
                id={inputId}
                onChange={onFileInputChange}
              />
              <Button
                size="sm"
                variant="outline"
                colorScheme="blue"
                borderRadius="md"
                onClick={() => document.getElementById(inputId).click()}
              >
                Choose File
              </Button>
              {selectedFile && !previewUrl && (
                <Text fontSize="xs" color="gray.500">{selectedFile.name}</Text>
              )}
              {previewUrl && (
                <VStack spacing={1}>
                  <Box
                    as="img"
                    src={previewUrl}
                    alt="Selected Preview"
                    w="150px"
                    h="150px"
                    objectFit="cover"
                    borderRadius="lg"
                  />
                  <Text fontSize="xs" color="gray.500">Preview</Text>
                </VStack>
              )}
            </VStack>
          </Center>
          <AlertDialogFooter paddingTop={4}>
            <Button
              ref={cancelRef}
              size="sm"
              borderRadius="md"
              onClick={onClose}
            >
              Cancel
            </Button>
            {isLoading ? (
              <Button colorScheme="blue" size="sm" borderRadius="md" ml={3}>
                <Center>
                  <TradingSpinner size="16px" />
                </Center>
              </Button>
            ) : (
              <Button
                colorScheme="blue"
                size="sm"
                borderRadius="md"
                isDisabled={!selectedFile}
                onClick={onConfirm}
                ml={3}
              >
                Submit
              </Button>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ProfilePicDialog;
